module.exports = __webpack_public_path__ + "img/controller-danmen.d43cb2be.png";